import React from "react";
import styled from "styled-components";
import { FaSpinner } from "react-icons/fa";

const FullScreen = styled.div`
  background-color: #ffffffd4;
  color: #102e51;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
`;

const Container = styled.div`
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
  position: absolute;
  text-align: center;
`;

const LoadingMessage = styled.div`
  margin-top: 15px;
`;

const FullScreenSpinner = () => {
  return (
    <FullScreen>
      <Container>
        <FaSpinner className="icon-spin fullscreen-loading" size="4rem" />
        <LoadingMessage>
          <small>LOADING</small>
        </LoadingMessage>
      </Container>
    </FullScreen>
  );
};

export default FullScreenSpinner;
